import type React from 'react';

import type { IconProps } from '~/components/icons/types';

import CoinsIcon from './CoinsIcon';
import EggCrackIcon from './EggCrackIcon';
import FileXIcon from './FileXIcon';
import GaugeIcon from './GaugeIcon';
import ScalesIcon from './ScalesIcon';
import StampIcon from './StampIcon';
import UserCircleIcon from './UserCircleIcon';

export { CoinsIcon, EggCrackIcon, FileXIcon, GaugeIcon, ScalesIcon, StampIcon, UserCircleIcon };

export interface AiExpertIconDescriptor {
  // Stable identifier persisted in the backend's ``ai_expert.icon`` column.
  // Decouples the saved value from the React component name so we can rename
  // components without breaking existing rows.
  key: string;
  // Human-readable label used for tooltip / aria-label.
  label: string;
  Icon: React.ComponentType<IconProps>;
}

// Canonical, ordered catalog of icons selectable for an AI expert.
export const AI_EXPERT_ICONS: AiExpertIconDescriptor[] = [
  { key: 'coins', label: 'Coins', Icon: CoinsIcon },
  { key: 'egg_crack', label: 'Egg Crack', Icon: EggCrackIcon },
  { key: 'file_x', label: 'File X', Icon: FileXIcon },
  { key: 'gauge', label: 'Gauge', Icon: GaugeIcon },
  { key: 'scales', label: 'Scales', Icon: ScalesIcon },
  { key: 'stamp', label: 'Stamp', Icon: StampIcon },
  { key: 'user_circle', label: 'User Circle', Icon: UserCircleIcon },
];

// Lookup: backend key → React component, for rendering already-saved icons.
export const AI_EXPERT_ICON_BY_KEY: Record<string, React.ComponentType<IconProps>> = Object.fromEntries(
  AI_EXPERT_ICONS.map(({ key, Icon }) => [key, Icon])
);
